import { render } from "./esco-mais-em-breve.vue?vue&type=template&id=d56f567e&scoped=true"
import script from "./esco-mais-em-breve.vue?vue&type=script&lang=js"
export * from "./esco-mais-em-breve.vue?vue&type=script&lang=js"

import "./esco-mais-em-breve.vue?vue&type=style&index=0&id=d56f567e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56f567e"]])

export default __exports__